import {
    useCallback
} from 'react';


export function useColorPalette(colors) {
    return useCallback((idx) => {
        return colors[idx % _.size(colors)];
    }, [colors]);
}

const blueColorPalette = [
    'tlw-fill-blue-900',
    'tlw-fill-blue-925',
    'tlw-fill-blue-975',
    'tlw-fill-blue-1200',
    'tlw-fill-blue-1250'
];

export function useBlueColorPalette() {
    return useColorPalette(blueColorPalette);
}
